import { render, staticRenderFns } from "./ClientsReportModal.vue?vue&type=template&id=72560e9e&scoped=true&"
import script from "./ClientsReportModal.vue?vue&type=script&lang=js&"
export * from "./ClientsReportModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientsReportModal.vue?vue&type=style&index=0&id=72560e9e&prod&scoped=true&lang=css&"
import style1 from "./ClientsReportModal.vue?vue&type=style&index=1&id=72560e9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72560e9e",
  null
  
)

export default component.exports